import { BaseVO } from './BaseVO';
import { CampaignVO } from './CampaignVO';

export class PrebuiltCampaignVO extends BaseVO {
    id: number;
    name: string;
    description: string;
    cvo: CampaignVO;
}